module.exports = __webpack_public_path__ + "images/ranking-85b6cf43.svg";